module.exports = __webpack_public_path__ + "img/entrance_plant_1.4bd89ce8.jpg";